import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { ICommitteeDeclarationOfInterest } from '../../shared/models/committee-details-declaration-of-interest';
import { ITableColumn } from '../../../controls/table/table-column';


@Component({
    selector: 'app-committee-details-declaration-of-interest',
    templateUrl: './committee-details-declaration-of-interest.component.html',
    styleUrls: ['./committee-details-declaration-of-interest.component.scss'],
    standalone: false
})
export class CommitteeDetailsDeclarationOfInterestComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() declarationOfInterest: ICommitteeDeclarationOfInterest[] = [];
  @Input() loading: boolean = true;
  subscriptions: Subscription = new Subscription();

  tableData: ICommitteeDeclarationOfInterest[] = [];
  tableColumns: ITableColumn<ICommitteeDeclarationOfInterest>[] = [];


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnInit(): void {

    this.initializeTableColumns();
    this.initializeTableData();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['declarationOfInterest'] &&
      changes['declarationOfInterest'].currentValue &&
      !changes['declarationOfInterest'].firstChange
    ) {
      this.declarationOfInterest =
        changes['declarationOfInterest'].currentValue;
      this.initializeTableData();
    }
  }

  initializeTableData() {
   if (this.declarationOfInterest) {
      this.tableData = this.declarationOfInterest;
    } else {
      this.tableData = [];
    }
  }
  initializeTableColumns() {
    let columns: ITableColumn<ICommitteeDeclarationOfInterest>[] = [
      {
        name: 'name',
        displayName: 'Full Name',
        isSortable: true,
        headerWidth: '350px',
      },
      {
        name: 'nominatingOrganisationName',
        displayName: 'Nominating Organisation',
        isSortable: true,
        headerWidth: '500px',
      },
      {
        name: 'employerName',
        displayName: 'Employer',
        isSortable: true,
        headerWidth: '250px',
      },
      {
        name: 'professionalPosition',
        displayName: 'Professional Position',
        isSortable: true,
        headerWidth: '180px',
      },
      {
        name: 'otherEmploymentOrPaymentForServices',
        displayName: 'Other Employment',
        isSortable: true,
        headerWidth: '240px',

      },
      {
        name: 'otherPositionsHeldVoluntary',
        displayName: 'Other Positions Held - Voluntary',
        isSortable: true,
        headerWidth: '350px',
      },
      {
        name: 'otherInterests',
        displayName: 'Other Interests',
        isSortable: true,
        headerWidth: '200px',
      },
      {
        name: 'roleType',
        displayName: 'Role Type',
        isSortable: true,
        headerWidth: '200px',
      },
    ];

    this.tableColumns = columns;
  }
}
